import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import Table from './Table';
import Search from './Search';
import { useNavigate } from 'react-router-dom';

const Domains: React.FC<{
  selectDomain: (domain: Domain) => void;
  domains: Domain[];
}> = ({ selectDomain, domains }) => {
  const navigate = useNavigate();

  const [filteredDomains, setFilteredDomains] = useState<Domain[]>(domains);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    setFilteredDomains(domains);
  }, [domains]);

  return (
    <Box>
      <Search
        setFilteredDomains={setFilteredDomains}
        updateSearchQuery={setSearchQuery}
        selectDomain={selectDomain}
        register={() =>
          navigate('/cns', {
            state: {
              registerState: {
                domainName: searchQuery,
                status: 'registering',
              },
            },
          })
        }
        domains={domains}
        searchQuery={searchQuery}
      />
      <Table
        domains={filteredDomains}
        searchQuery={searchQuery}
        parentDomain="cam"
        selectDomain={selectDomain}
      />
    </Box>
  );
};

export default React.memo(Domains);
